export default [
    {
        path: '/vacancy-control',
        name: 'vacancy-control',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Gestão de Vagas',
            icon: 'mdi-car-cruise-control',
            breadcrumbs: [
                { text: 'Gestão de Vagas', disabled: true }
            ]
        }
    }
]
